import { render, staticRenderFns } from "./CascadingScalePerformanceValuesInputTableColumn.vue?vue&type=template&id=21e15af2"
import script from "./CascadingScalePerformanceValuesInputTableColumn.vue?vue&type=script&lang=js"
export * from "./CascadingScalePerformanceValuesInputTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CascadingScalePerformanceValuesInputTableColumn.vue?vue&type=style&index=0&id=21e15af2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports